import Severity from '@/shared/constants/Severity';

export default class JobChecklistDetails {
  status: Severity | null = null;
  checklistDescription = '';
  itemDescription = '';
}